import VehicleTrace from './vehicle-trace'
export default VehicleTrace
